class SlickSlideshowComponent extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.swiper-brand');
    if (!swiperEl) return;
    var swiper = new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 30,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loop: true,
      freeMode: true,
      allowTouchMove: true,
      speed: 5000,
      pauseOnMouseEnter: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 7,
        },
      },
    });
  }
}

customElements.define('slick-slideshow-component', SlickSlideshowComponent);
